import BaseCard from 'components/Cards/BaseCard';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import FloodSettingsField from '../../../../../components/FloodSettingsField/FloodSettingsField';
import SettingButton from '../../../../../components/SettingButton/SettingButton';
import { CARD_CLASS_NAMES } from '../../../../../config/floodDeviceConfig';

const formatHour = (value) => `${String(value ?? 0).padStart(2, '0')}:00`;

export default function AdditionalSettingsCard({
  deviceSettings,
  setDeviceSettings,
  device,
  enabled,
}) {
  return (
    <BaseCard
      className={`shadow-sm ${CARD_CLASS_NAMES.card}`}
      header="Additional Settings"
      headerClassName={CARD_CLASS_NAMES.cardHeader}
      bodyClassName={`d-flex flex-column gap-3 ${CARD_CLASS_NAMES.cardBody}`}
    >
      <SettingButton
        displayName="External Device"
        settingName="externalDevice"
        deviceSettings={deviceSettings}
        setDeviceSettings={setDeviceSettings}
        device={device}
        enabled={enabled}
      />

      <SettingButton
        displayName="Triggered Imaging Holdoff"
        settingName="imgHoldEnable"
        deviceSettings={deviceSettings}
        setDeviceSettings={setDeviceSettings}
        device={device}
        enabled={enabled}
      />

      <FloodSettingsField
        label="Hour Start"
        type="time"
        value={formatHour(deviceSettings?.imgHoldStart)}
        disabled={!deviceSettings?.imgHoldEnable || !enabled}
        onChange={(e) =>
          setDeviceSettings((prev) => ({
            ...prev,
            imgHoldStart: parseInt(e.target.value.split(':')[0]),
          }))
        }
      />

      <FloodSettingsField
        label="Hour End"
        type="time"
        value={formatHour(deviceSettings?.imgHoldEnd)}
        disabled={!deviceSettings?.imgHoldEnable || !enabled}
        onChange={(e) =>
          setDeviceSettings((prev) => ({
            ...prev,
            imgHoldEnd: parseInt(e.target.value.split(':')[0]),
          }))
        }
      />

      <Form.Group as={Row} className="align-items-center g-2">
        <Form.Label column lg={5} className="mb-0">
          Water Level Adj.
        </Form.Label>
        <Col lg={7} className="d-flex justify-content-lg-end">
          <InputGroup style={{ width: 140 }}>
            <Form.Control
              className="bg-primary border-0"
              type="number"
              value={deviceSettings?.water_level_adj ?? ''}
              disabled={!enabled}
              onChange={(e) =>
                setDeviceSettings((prev) => ({
                  ...prev,
                  water_level_adj: e.target.value === '' ? '' : parseFloat(e.target.value),
                }))
              }
              style={{ textAlign: 'left' }}
            />
            <InputGroup.Text className="text-dark bg-white border-0 px-1">inches</InputGroup.Text>
          </InputGroup>
        </Col>
      </Form.Group>
    </BaseCard>
  );
}
